<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar flat color="transparent" height="50">
          <h3 class="hidden-sm-and-down">Danh sách sim ({{totalSim}})</h3>
          <h4 class="hidden-md-and-up">Sim ({{totalSim}})</h4>
          <v-spacer></v-spacer>
          <div class="text-xs-center">
            <v-menu offset-y>
              <template slot="activator">
                <v-btn color="primary">Menu
                  <v-icon>expand_more</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile avatar v-for="(item, index) in buttons" :key="index" :to="item.url">
                  <v-list-tile-action>
                    <v-icon :color="item.color">{{item.icon}}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar>
        <v-flex lg12>
          <sim-table :isLoading="isLoading" :datasource="sims" :total-items="totalSim" @changePage="changePage"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-speed-dial bottom right fixed class="hidden-md-and-up" v-model="fab">
      <v-btn slot="activator" color="red" dark fab v-model="fab">
        <v-icon>add</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn fab dark small color="green" to="/sim/import">
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn fab dark small color="primary" to="/sim/export">
        <v-icon>import_export</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as Utils from '@/utils';
import SimTable from './components/list';

export default {
  components: {
    SimTable
  },
  data () {
    return {
      isLoading: false,
      fab: false,
      buttons: [
        {
          text: 'Nhập sim',
          icon: 'add',
          color: 'green',
          url: '/sim/import'
        },
        {
          text: 'Xuất sim',
          icon: 'import_export',
          color: 'primary',
          url: '/sim/export'
        },
        {
          text: 'Thu hồi sim',
          icon: 'subdirectory_arrow_left',
          color: 'teal',
          url: '/sim/return'
        },
        {
          text: 'Cập nhật dung lượng',
          icon: 'data_usage',
          color: 'cyan cyan darken-1',
          url: '/sim/updatedata'
        },
        {
          text: 'Sim không phát sinh dung lượng',
          icon: 'sim_card',
          color: 'red',
          url: '/sim/datareporting'
        }
      ],
      pagination: {
        keySearch: '',
        pageIndex: 1,
        pageSize: 10
      }
    };
  },
  computed: {
    ...mapGetters(['sims', 'loggedUser', 'totalSim']),
    // totalSim () {
    //   return this.sims.length;
    // },
    displayButton () {
      return this.loggedUser.isProvider || this.loggedUser.isDistributor;
    }
  },
  created () {
    this.isLoading = true;
    this.getSims(this.pagination).then(_ => {
      this.isLoading = false;
    });
  },
  methods: {
    ...mapActions(['getSims']),

    changePage (pagination) {
      this.isLoading = true;
      this.getSims(pagination).then(_ => {
        this.isLoading = false;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/sim/index.vue